export const STREAMING_GET_MY_ACTIVE_STREAM = "STREAMING_GET_MY_ACTIVE_STREAM";
export const STREAMING_ADD_MY_STREAM = "STREAMING_ADD_MY_STREAM";
export const STREAMING_UPDATE_MY_STREAM = "STREAMING_UPDATE_MY_STREAM";
export const STREAMING_UPDATE_MY_STREAM_DETAILS = "STREAMING_UPDATE_MY_STREAM_DETAILS";
export const STREAMING_ADDNEW_TV = "STREAMING_ADDNEW_TV";
export const STREAMING_UPDATE_TV = "STREAMING_UPDATE_TV";
export const STREAMING_ALL_TVs = "STREAMING_ALL_TVs";
export const STREAMING_DELETE_TV = "STREAMING_DELETE_TV";
export const STREAMING_GET_MY_EVENT_EARNINGS = "STREAMING_GET_MY_EVENT_EARNINGS";
export const STREAMING_GET_MY_EVENT_CHATS = "STREAMING_GET_MY_EVENT_CHATS";
export const STREAMING_CHECK_STREAM_STATUS = "STREAMING_CHECK_STREAM_STATUS";
export const STREAMING_ADD_STREAM_LOCATION = "STREAMING_ADD_STREAM_LOCATION";
export const STREAMING_UPDATE_STREAM_LOCATION = "STREAMING_UPDATE_STREAM_LOCATION";
export const STREAMING_DELETE_STREAM_LOCATION = "STREAMING_DELETE_STREAM_LOCATION";
export const STREAMING_GET_ALL_STREAM_LOCATION = "STREAMING_GET_ALL_STREAM_LOCATION";
export const STREAMING_GET_STREAM_SESSIONS = "STREAMING_GET_STREAM_SESSIONS";
export const STREAMING_SET_DEFAULT_DEMPED_HLS = "STREAMING_SET_DEFAULT_DEMPED_HLS";
export const STREAMING_GET_EVENT_VIEWS = "STREAMING_GET_EVENT_VIEWS";
export const STREAMING_GET_PAST_STREAMS = "STREAMING_GET_PAST_STREAMS";
export const STREAMING_UPDATE_STREAM = "STREAMING_UPDATE_STREAM";
export const STREAMING_SET_STREAM_ACTIVE = "STREAMING_SET_STREAM_ACTIVE";
export const STREAMING_DELETE_STREAM = "STREAMING_DELETE_STREAM";
export const STREAMING_DELETE_STREAM_SESSION = "STREAMING_DELETE_STREAM_SESSION";
export const STREAMING_MERGE_STREAM = "STREAMING_MERGE_STREAM";
export const STREAMING_DOWNLOAD_STREAM = "STREAMING_DOWNLOAD_STREAM";
export const STREAMING_GET_STREAM_DOWNLOADS = "STREAMING_GET_STREAM_DOWNLOADS";
export const STREAMING_GET_STREAM_ANALYTICS = "STREAMING_GET_STREAM_ANALYTICS";
export const STREAMING_GET_STREAM_LOGS = "STREAMING_GET_STREAM_LOGS";
export const STREAMING_GET_STREAM_HEALTH = "STREAMING_GET_STREAM_HEALTH";
export const STREAMING_CLOSE_MY_STREAM = "STREAMING_CLOSE_MY_STREAM";
export const STREAMING_END_MY_STREAM = "STREAMING_END_MY_STREAM";
export const STREAMING_SEND_MY_EVENT_CHAT = "STREAMING_SEND_MY_EVENT_CHAT";